
import { defineComponent } from 'vue'
import { insurePeriodReportCaseListApi, outDangerDetailByIdApi, materialsAddFileApi } from '@/api/long-insure-new'
import { BillDetailDto, BillDto } from '@/api/bill'
import { payrollDelete } from '@/api/payroll'
import batchPayroll from '@/components/batch-payroll.vue'
import global from '@/utils/global'
import { formatter, filterIdCard } from '@/utils/util'
import { reportStatusList, accidentTypeList, flagList, superHurtTypeList, accidentStatusList, treatmentMethodList, accidentCauseList } from '@/utils/insure-daily-ax-dict'
import dayjs from 'dayjs'

export default defineComponent({
  name: 'LongInsureReport',
  components: {
    batchPayroll
  },
  data() {
    return {
      isBatchPay: false,
      pageSize: 10,
      pageNum: 1,
      total: 0,
      tableData: [] as BillDetailDto[],
      searchText: '',
      searchValue: '',
      detailInfo: {} as BillDto,
      selects: [] as string[],
      curItem: {} as any,
      uploadStatus: '',
      formatter,
      filterIdCard,
      reportStatusList,
      accidentTypeList,
      flagList,
      superHurtTypeList,
      accidentStatusList,
      treatmentMethodList,
      accidentCauseList,
      showDrawer: false,
      staffBaseInfo: {} as any,
      userPlanInfo: {} as any,
      processList: [] as any,
      cardNumShow: false,
      imageViewerVisible: false,
      previewImages: [] as string[],
      // 每类附件的上限
      fileLimit: 9,
      // caseFileList 按 type 归集：{ 1: ['url', ...], 2: [...] }
      caseFileMap: {} as Record<number, string[]>,
      uploadAction: process.env.VUE_APP_BASE_URL + '/rest/period-insur/serve-company/upload',
      Authorization: 'Bearer' + ' ' + global.token,
      // 多选上传是逐个文件回调，等全部结束再统一提交、刷新详情
      uploadingCount: 0,
      // 本批上传成功的地址，按 attachmentType 归集
      pendingFiles: {} as Record<number, string[]>,
      // 每类附件正在上传中的数量，用于限制不超过 fileLimit
      uploadingMap: {} as Record<number, number>,
      staffColumnItem: [
        { label: '出险人', field: 'outDangerUserName', showType: 'normal' },
        { label: '出险人身份证', field: 'outDangerIdCardNo', showType: 'idCardNo' },
        { label: '保险商品', field: 'companyPlanName', showType: 'normal' },
        { label: '在保时间', field: '', showType: 'time' },
        { label: '派遣单位', field: 'serveCompanyName', showType: 'childObj' },
        { label: '报案时间', field: 'createTime', showType: 'normal' },
        { label: '系统工种', field: '', showType: 'occupation', span: 2 },
        { label: '出险人手机号', field: 'outDangerPhone', showType: 'normal' },
        { label: '报案人手机号', field: 'reportPhone', showType: 'normal' },
        { label: '出险时间', field: 'outDangerDate', showType: 'normal' },
        { label: '是否住院', field: 'hospitalStatus', showType: 'option' },
        { label: '是否骨折', field: 'hurtStatus', showType: 'option' },
        { label: '是否手术', field: 'surgeryStatus', showType: 'option' },
        { label: '事故类型', field: 'accidentType', showType: 'option' },
        { label: '出险地点', field: 'outDangerPlace', showType: 'normal' },
        { label: '受伤部位', field: 'injuredArea', showType: 'normal' },
        { label: '就诊医院', field: 'visitHospital', showType: 'normal' },
        { label: '出险状态', field: 'accidentStatus', showType: 'option' },
        { label: '治疗方式', field: 'treatmentMethod', showType: 'option' },
        { label: '诊断结果', field: 'diagnosisResult', showType: 'normal' },
        { label: '出险原因', field: 'accidentCause', showType: 'option' },
        { label: '当前花费', field: 'currentCost', showType: 'money' },
        { label: '事故视频', field: '', showType: 'video' },
        { label: '事故经过', field: 'accidentDetails', showType: 'normal', span: 2 },
        // type 1~7 与 caseFileList 里的 type 一一对应
        { label: '事故现场情况及周边环境', field: '', showType: 'files', type: 1 },
        { label: '伤者全身照', field: '', showType: 'files', type: 2 },
        { label: '受伤部位特写', field: '', showType: 'files', type: 3 },
        { label: '诊断证明', field: '', showType: 'files', type: 4 },
        { label: '首诊病例', field: '', showType: 'files', type: 5 },
        { label: '检查报告', field: '', showType: 'files', type: 6 },
        { label: '挂号单据', field: '', showType: 'files', type: 7 }
      ]
    }
  },
  async created() {
    this.getPayrollList()
  },
  methods: {
    async getPayrollList() {
      const result = await insurePeriodReportCaseListApi({
        insureType: 2,
        searchText: this.searchValue,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        uploadStatus: this.uploadStatus
      })
      this.total = result.totalCount
      this.tableData = result.list
    },
    handleSizeChange() {
      this.pageNum = 1
      this.getPayrollList()
    },
    // 空值统一显示 --
    emptyText(val: any) {
      return val === '' || val === null || val === undefined ? '--' : val
    },
    // 点击出险人，打开详情抽屉
    async onClickName(row: any) {
      this.curItem = row
      this.showDrawer = true
      // 必须重置，否则连续查看不同案件时进展会累加
      this.processList = []
      this.staffBaseInfo = {}
      this.userPlanInfo = {}
      this.caseFileMap = {}
      this.cardNumShow = false

      const result = await outDangerDetailByIdApi(row.reportNo as string)
      result?.reportCaseResultList?.forEach((item: { reportSolveResult: string; remark: string; createTime: string; desc: number }) => {
        this.processList.push({
          type: 'primary',
          hollow: true,
          reportSolveResult: item.reportSolveResult,
          timestamp: item.createTime,
          remark: item.remark,
          desc: item.desc
        })
      })
      this.staffBaseInfo = result
      this.staffBaseInfo['cardNumber'] = this.filterIdCard(result.outDangerIdCardNo)
      this.userPlanInfo = result.userPlanInfo || {}
      this.setCaseFileMap((result as any).caseFileList)
    },
    // caseFileList 按 type 归集；同一 type 可能有多条（category 不同），需要合并而非覆盖
    setCaseFileMap(caseFileList: any) {
      const map = {} as Record<number, string[]>
      ;(caseFileList || []).forEach((item: any) => {
        const type = Number(item.type)
        if (!map[type]) map[type] = []
        map[type] = map[type].concat((item.fileUrls || []).filter(Boolean))
      })
      this.caseFileMap = map
    },
    // 取某一类附件的文件地址列表
    getCaseFiles(type: any) {
      return this.caseFileMap[Number(type)] || []
    },
    // 预览某一类附件
    onPreviewFiles(item: any) {
      const list = this.getCaseFiles(item.type)
      if (!list.length) {
        this.$message.warning('暂无附件')
        return
      }
      this.previewImages = list
      this.imageViewerVisible = true
    },
    onBeforeUpload(item: any, file: any) {
      const type = Number(item.type)
      // 多选时逐个校验，已上传的 + 本批正在传的都要算进去
      const remain = this.fileLimit - this.getCaseFiles(type).length - (this.uploadingMap[type] || 0)
      if (remain <= 0) {
        this.$message.warning(`${item.label}最多上传${this.fileLimit}张`)
        return false
      }
      if (!['image/jpeg', 'image/jpg', 'image/png'].includes(file.type)) {
        this.$message.error('只能上传jpg/png格式的图片')
        return false
      }
      if (file.size / 1024 / 1024 > 10) {
        this.$message.error('单张图片不可大于10M')
        return false
      }
      this.uploadingMap[type] = (this.uploadingMap[type] || 0) + 1
      this.uploadingCount++
      return true
    },
    onUploadSuccess(item: any, response: { code: number; msg: string; data: { fileUrl: string } }) {
      if (response && response.code === 500) {
        this.$message.error(response.msg)
      } else if (response?.data?.fileUrl) {
        const type = Number(item.type)
        if (!this.pendingFiles[type]) this.pendingFiles[type] = []
        this.pendingFiles[type].push(response.data.fileUrl)
      }
      this.afterUpload()
    },
    onUploadError() {
      this.$message.error('上传失败，请重试')
      this.afterUpload()
    },
    // 一批文件全部传完后再统一提交附件并刷新详情，避免多选时重复请求
    async afterUpload() {
      this.uploadingCount--
      if (this.uploadingCount > 0) return
      this.uploadingCount = 0
      this.uploadingMap = {}

      const fileList = Object.keys(this.pendingFiles)
        .map((type) => ({ attachmentType: Number(type), fileUrl: this.pendingFiles[Number(type)] }))
        .filter((i) => i.fileUrl.length)
      this.pendingFiles = {}

      if (fileList.length) {
        try {
          await materialsAddFileApi({ reportNo: this.curItem.reportNo, fileList })
          this.$message.success('上传成功')
        } catch (e) {
          // 提交失败的提示由请求层统一给出，这里仍然刷新一次保证展示与后台一致
        }
      }
      if (this.curItem.reportNo) this.onClickName(this.curItem)
      this.getPayrollList()
    },
    onClickCardNo() {
      this.cardNumShow = !this.cardNumShow
    },
    goBack() {
      this.showDrawer = false
    },
    // 在保结束时间为 2099-01-01 表示长期有效
    checkInsureEndTime(insureEndTime: string) {
      if (!insureEndTime) return '长期有效'
      const endDate = dayjs(insureEndTime).format('YYYY-MM-DD')
      return endDate === '2099-01-01' ? '长期有效' : insureEndTime
    },
    onAdd() {
      console.log('onAdd')
      this.$router.push({
        path: '/long-insure-report-add',
        query: {
          insureType: 2
        }
      })
    },
    search() {
      this.searchValue = this.searchText
      this.pageNum = 1
      this.getPayrollList()
    },
    onReset() {
      this.searchText = ''
      this.search()
    },
    handleSelectionChange(selects: { id: string }[]) {
      this.selects = selects.map((item) => item.id)
    },
    /**
     * 删除勾选工资单
     */
    async onDelete() {
      const str = this.selects.join(',')
      if (str.length === 0) {
        this.$message.warning('请至少选择一个！')
        return
      }
      await payrollDelete(str)
      this.getPayrollList()
      this.$message.success('删除成功！')
    }
  }
})
